import { useRouter } from 'next/router';

import { useTranslate } from '../../hooks/useTranslate';
import { Logo } from './components/Logo/Logo';
import { SideMenuButton } from './components/SideMenuButton/SideMenuButton';
import { TagsMenu } from './components/TagsMenu/TagsMenu';
import { User } from './components/User/User';
import {
  Container,
  Group,
  Nav,
  StyledHeader,
  StyledLink,
} from './Header.styles';
import { HeaderProps } from './Header.types';

export const Header = ({
  isNavigationEnabled,
  isSideMenuEnabled,
  tags,
  onAuthClick,
}: HeaderProps) => {
  const { t } = useTranslate();
  const { pathname } = useRouter();
  const isMyTripsPage = pathname === '/[market]/my-trips';

  return (
    <StyledHeader>
      <Container>
        <Group>
          <Logo />

          {isNavigationEnabled && (
            <Nav>
              {tags && !!tags.length && <TagsMenu tags={tags} />}

              <StyledLink href="/my-trips" isActive={isMyTripsPage}>
                {t('ui.navigation.myTrips')}
              </StyledLink>
            </Nav>
          )}
        </Group>

        <Group>
          <User onAuthClick={onAuthClick} />

          {isSideMenuEnabled && <SideMenuButton />}
        </Group>
      </Container>
    </StyledHeader>
  );
};
